<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 col-xl-8 mb-4 mb-xl-0">
                        <h3 class="font-weight-bold">Received Reports</h3>
                    </div>
                    <div class="col-12 col-xl-4">

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">

                <div class="row mb-3">
                      <div class="col-sm-4 col-md-6 col-12 stretch-card col-grid"></div>

                    <div class="col-sm-4 col-md-4 col-8 stretch-card col-grid">
                 <input class="date_input form-control" placeholder="ID or Phone or Parcel name" type="text" v-model="this._search">
                    </div>
                
                    <div class="col-sm-4 col-md-2 col-4 stretch-card col-grid">
                         <button id="filter_btn" @click="searchParcel" class="btn btn-primary simple-btn">Search</button>
                    </div>
                    
                </div>

                 <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>

                                             <div id="data-head" class="text-center">
                   <h4>{{ this.heading }}</h4>
                </div>

                  <div class="col-md-12 grid-margin stretch-card" v-for="(parcel, index) in paginatedParcels" :key="parcel.id">
            <div class="card">
                <div class="card-body">
                    <h4 class="text-center mb-3">Package Name : <b>{{parcel.name}}</b></h4>
                    <div class="row">
                        <div class="col-sm-6 col-md-4 mb-3">
                            <h5>Sender name: <b>{{parcel.sender_name}}</b></h5>
                            <h5>Sender Phone: <b>{{parcel.sender_phone}}</b></h5>
                            <br>
                            <h5>Receiver name: <b>{{parcel.receiver_name}}</b></h5>
                            <h5>Receiver Phone: <b>{{parcel.receiver_phone}}</b></h5>
                        </div>

                        <div class="col-sm-6 col-md-4 mb-3">
                            <h5><b class="text-primary">{{parcel.bfname}}</b> To <b class="text-success">{{parcel.btname}}</b></h5>

                            <h5>Created at: <b><DateFormat :Date_="parcel.created_at"/></b></h5>
                            <h5>Transportation Price: <b><PriceFormat :Price="parcel.price"/></b></h5>

                            <h5 v-if="parcel.status == 1">Package status: <label class="badge badge-primary">On Transit</label></h5>
                            <h5 v-if="parcel.status == 2">Package status: <label class="badge badge-success">Received</label></h5>
                            <h5 v-if="parcel.status == 3">Package status: <label class="badge badge-danger">Removed</label></h5>
                         
                        </div>

                        <div class="col-sm-6 col-md-4 mb-3">
                            <h5>Staff name: <b>{{parcel.fulname}}</b></h5>
                            <h5>Staff Phone: <b>{{parcel.phone1}}</b></h5>
                            <br>
                            <h5>Transporter name: <b>{{parcel.transporter_name}}</b></h5>
                            <h5>Transporter Phone: <b>{{parcel.transporter_phone}}</b></h5>
                        </div>

                    </div>
                </div>
            </div>
        </div>
                           <div v-if="parcels.length" class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
            </div>
        </div>
    </div>

</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            heading:"",
            _search: "",
            parcels:[],
            og_parcels:[],
            currentPage: 1,
            perPage: 10,
            user: this.$attrs.user
        };
    },
    methods: {

        async searchParcel(){

        this.loading = true

          var _search = this._search

          var response = await axios
              .post(this.$store.state.api_url + "/search-parcels", {_search})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.parcels = response.data.parcels;
                this.og_parcels = response.data.parcels

                this.heading = "Parcels Result For "+_search
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },
         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

    },
      computed: {

  paginatedParcels() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.parcels.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.parcels.length / this.perPage)
  },
  

},
    watch: {

    },
    created() {
        this.$store.state.page_name = "Dashbord"
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
